<template>
    <div class="alliance">
        <div style="display:flex;justify-content: center;padding:40px 0;">
            <el-form :label-position="labelPosition" label-width="220px" :model="ruleForm" style="width: 680px;" :rules="rules" ref="ruleForm">
                <el-form-item label="您的姓名" required prop="createdBy">
                    <el-input v-model="ruleForm.createdBy"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" required prop="phone">
                    <el-input v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <!-- 临时隐藏：是否从事物流相关行业、是否已有发货客户资源 -->
                <!-- <el-form-item label="您目前是否从事物流相关行业" required prop="whetherWorkOnLogistics">
                    <el-select v-model="ruleForm.whetherWorkOnLogistics" style="width: 100%;" placeholder="">
                        <el-option label="是" value="1"/>
                        <el-option label="否" value="0"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="您目前是否已有发货客户资源" required prop="joinCustomerResources">
                    <el-select v-model="ruleForm.joinCustomerResources" style="width: 100%;" placeholder="">
                        <el-option label="是" value="1"/>
                        <el-option label="否" value="0"/>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="投资额" required  prop="joinInvestment">
                    <el-select v-model="ruleForm.joinInvestment" style="width: 100%;" placeholder="">
                        <el-option label="20万以下" value="20万以下"/>
                        <el-option label="20-30万" value="20-30万"/>
                        <el-option label="30-50万" value="30-50万"/>
                        <el-option label="50万以上" value="50万以上"/>
                    </el-select>
                    <div style="font-size: 10px;color: #adadad;line-height: 14px;">建议新入物流行业20万开店投入及30万大客户月结流动资金</div>
                </el-form-item>
                <el-form-item label="您意向加盟/发货地区" required>
                    <div style="width: 100%;display: flex;justify-content: space-between;">
                        <el-form-item style="width: 33%;display: flex;" prop="provinceCode">
                            <el-select v-model="ruleForm.provinceCode" @change="onProvinceChange" placeholder="省" >
                                <el-option v-for="item in provinceList" :key="item.code" :label="item.name" :value="item.code" ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="width: 33%" prop="cityCode">
                            <el-select v-model="ruleForm.cityCode" @change="onCityChange" placeholder="市" >
                                <el-option v-for="item in cityList" :key="item.code" :label="item.name" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="width: 33%" prop="districtCode">
                            <el-select v-model="ruleForm.districtCode" @change="onDistrictChange" placeholder="区" >
                                <el-option v-for="item in districtList" :key="item.code" :label="item.name" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="其它需求" prop="remarks">
                    <el-input v-model="ruleForm.remarks" type="textarea" placeholder="200字以内留言"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="captcha">
                    <div style="display:flex;justify-content: space-between;">
                        <div style="width: 33%"><el-input v-model="ruleForm.captcha"></el-input></div>
                        <div style="width: 33%;display:flex;align-items: center;"><img :src="captchaUrl" alt="点击刷新" id="img" height="38" width="140"/></div>
                        <div style="width: 33%"><span class="huanyi" @click="changeCaptcha()">看不清，换一张?</span></div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button class="btn" type="primary" @click="submitForm('ruleForm')" >确认提交 <i class="el-icon-caret-right"></i></el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import { insertbussinessjoin, querycaption } from "@/api/homePage";
    var i = 1;
    export default {
        data() {
            return {
                labelPosition: 'right',
                ruleForm: {
                    createdBy: "",
                    phone: "",
                    provinceCode: "",
                    provinceName: "",
                    email: "",
                    province: "",
                    cityCode: "",
                    cityName: "",
                    districtCode: "",
                    districtName: "",
                    isSing: "",
                    remarks: "",
                    captcha: "",
                    platform: "1",
                    // whetherWorkOnLogistics: "",
                    // joinCustomerResources: "",
                    whetherWorkOnLogistics: 0, // 临时隐藏字段，保留默认值
                    joinCustomerResources: 0, // 临时隐藏字段，保留默认值
                    joinInvestment:""
                },
                captchaUrl: "",
                provinceList: [],
                cityList: [],
                districtList: [],
                rules: {
                    createdBy: [
                        {
                            required: true,
                            message: "请输入姓名",
                            trigger: "blur"
                        },
                        {
                            min: 2,
                            max: 10,
                            message: "姓名长度在 2 到 10 个字符",
                            trigger: "blur"
                        }
                    ],
                    phone: [
                        {
                            required: true,
                            message: "请输入手机号",
                            trigger: "blur"
                        },
                        {
                            min: 1,
                            max: 12,
                            message: "手机长度在12个字符",
                            trigger: "blur"
                        },
                        {
                            pattern: /^[0-9]+$/,
                            message: "电话号码格式不对"
                        }
                    ],
                    // 临时隐藏：是否从事物流相关行业、是否已有发货客户资源
                    // whetherWorkOnLogistics: [
                    //     {
                    //         required: true,
                    //         message: "请选择您目前是否从事物流相关行业",
                    //         trigger: "blur"
                    //     }
                    // ],
                    // joinCustomerResources: [
                    //     {
                    //         required: true,
                    //         message: "请选择您目前是否已有发货客户资源",
                    //         trigger: "blur"
                    //     }
                    // ],
                    joinInvestment: [
                        {
                            required: true,
                            message: "请选择投资额",
                            trigger: "blur"
                        }
                    ],
                    provinceCode: [
                        {
                            required: true,
                            message: "请选择省份",
                            trigger: "change"
                        }
                    ],
                    cityCode: [
                        {
                            required: true,
                            message: "请选择市",
                            trigger: "change"
                        }
                    ],
                    districtCode: [
                        {
                            required: true,
                            message: "请选择区",
                            trigger: "change"
                        }
                    ],
                    remarks: [
                        {
                            max: 200,
                            message: "留言长度在200个字符以内",
                            trigger: "blur"
                        }
                    ],
                    captcha: [
                        {
                            required: true,
                            message: "请输入验证码",
                            trigger: "blur"
                        }
                    ]
                }
            }
        },
        watch: {
            $route(to, from) {
                this.changeCaptcha();
            }
        },
        created() {
            this.queryProvince();
            this.changeCaptcha();
        },
        mounted() {
            this.changeCaptcha();
        },
        methods:{
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        insertbussinessjoin(this.ruleForm)
                            .then(res => {
                                if (res.status === 2000) {
                                    this.handleCrmSubmitResult(res.data, formName);
                                } else if (
                                    (res.status === 5100 || res.message === "重复提交") &&
                                    res.data
                                ) {
                                    // 兼容旧接口：有 CRM 数据时解析展示网销经理
                                    this.handleCrmSubmitResult(res.data, formName);
                                } else if (
                                    res.status === 5100 ||
                                    res.message === "重复提交"
                                ) {
                                    this.showResultAlert(
                                        false,
                                        "您的加盟意向已收到，无需重复提交~"
                                    );
                                } else {
                                    this.showResultAlert(false, res.message || "验证码有误请刷新重试");
                                    this.changeCaptcha();
                                }
                            })
                            .catch(err => {
                                this.showResultAlert(false, (err && err.message) || String(err) || "提交失败");
                            });
                    } else {
                        return false;
                    }
                });
            },
            handleCrmSubmitResult(crmRes, formName) {
                const crm = crmRes || {};
                const data = crm.data || {};
                const result = data.result || {};
                const isSuccess = data.success === true;
                const crmMsg = crm.message || "";
                const isDuplicate =
                    crmMsg.indexOf("重复") !== -1 ||
                    crmMsg.indexOf("无需重复提交") !== -1;
                if (isSuccess) {
                    const followEmpName = result.followEmpName || "";
                    const mobile = result.followEmpMobile || "";
                    let msg = "已收到您的加盟意向，我们会尽快联系您~";
                    if (followEmpName || mobile) {
                        msg += "\n";
                        if (followEmpName) msg += "网销经理：" + followEmpName + "\n";
                        if (mobile) msg += "联系电话：" + mobile;
                    }
                    this.showResultAlert(true, msg, () => {
                        this.$refs[formName].resetFields();
                        this.changeCaptcha();
                    });
                } else {
                    let msg = isDuplicate
                        ? "您的加盟意向已收到，无需重复提交~"
                        : crmMsg;
                    if (!msg && crm.errors && crm.errors.length) {
                        msg = crm.errors[0].errorMsg || "";
                    }
                    if (!msg) {
                        msg = crm.error || "提交失败";
                    }
                    const followEmpName =
                        result.followEmpName || result.userName || "";
                    const mobile =
                        result.followEmpMobile || result.mobile || "";
                    if (followEmpName || mobile) {
                        msg += "\n";
                        const nameLabel = isDuplicate ? "网销经理" : "联系人";
                        if (followEmpName) msg += nameLabel + "：" + followEmpName + "\n";
                        if (mobile) msg += "联系电话：" + mobile;
                    }
                    this.showResultAlert(false, msg, () => {
                        this.changeCaptcha();
                    });
                }
            },
            showResultAlert(isSuccess, message, callback) {
                const htmlMsg = String(message || "").replace(/\n/g, "<br/>");
                this.$alert(htmlMsg, isSuccess ? "提交成功" : "提示", {
                    confirmButtonText: "确定",
                    type: isSuccess ? "success" : "warning",
                    dangerouslyUseHTMLString: true,
                    callback: () => {
                        if (typeof callback === "function") {
                            callback();
                        }
                    }
                });
            },
            queryProvince() {
                querycaption({ parentCode: "100000" }).then(res => {
                    if (res.status === 2000) {
                        this.provinceList = res.data;
                    }
                });
            },
            onProvinceChange() {
                const matched = this.provinceList.find(
                    p => p.code === this.ruleForm.provinceCode
                );
                this.ruleForm.provinceName = matched ? matched.name : "";
                this.ruleForm.cityCode = "";
                this.ruleForm.cityName = "";
                this.ruleForm.districtCode = "";
                this.ruleForm.districtName = "";
                this.cityList = [];
                this.districtList = [];
                if (this.ruleForm.provinceCode) {
                    querycaption({ parentCode: this.ruleForm.provinceCode }).then(
                        res => {
                            if (res.status === 2000) {
                                this.cityList = res.data;
                            }
                        }
                    );
                }
            },
            onCityChange() {
                const matched = this.cityList.find(
                    c => c.code === this.ruleForm.cityCode
                );
                this.ruleForm.cityName = matched ? matched.name : "";
                this.ruleForm.districtCode = "";
                this.ruleForm.districtName = "";
                this.districtList = [];
                if (this.ruleForm.cityCode) {
                    querycaption({ parentCode: this.ruleForm.cityCode }).then(res => {
                        if (res.status === 2000) {
                            this.districtList = res.data;
                        }
                    });
                }
            },
            onDistrictChange() {
                const matched = this.districtList.find(
                    d => d.code === this.ruleForm.districtCode
                );
                this.ruleForm.districtName = matched ? matched.name : "";
            },
            changeCaptcha() {
                this.captchaUrl = this.GLOBAL + "nologinsystem/captcha?" + i++;
            }
        }
    }
</script>
<style scoped>
    .alliance{
        width: 100%;
    }
    .required::before{
        content: "*";
        color: red;
    }
    .huanyi:hover{
        cursor: pointer;
    }
    .btn {
        width: 100%;
        border-radius: 6px;
        border: 2px solid;
        font-size: 16px;
        background: none;
        outline: none;
        cursor: pointer;
        transition: all 1s;
        color: #fabe00;
        border-color: #fabe00;
        background: -webkit-linear-gradient(
                left,
                #fabe00,
                #fabe00
        )
        no-repeat;
        background: linear-gradient(to right, #fabe00, #fabe00)
        no-repeat;
        background-size: 0% 100%;
    }
    .btn:hover {
        background-size: 100% 100%;
        color: #000;
    }
</style>
